import type { AstComment } from "@ext/git/core/Diff/logic/commentsDiff/CommentsDiff";
import type { Node } from "prosemirror-model";

// Text carries a comment as a mark, images, diagrams and other commentable nodes carry it as an attr.
const commentIdOf = (node: Node): string | undefined =>
	node.isText ? node.marks.find((mark) => mark.type.name === "comment")?.attrs.id : node.attrs.comment?.id;

const collectComments = (doc: Node): AstComment => {
	const comments: AstComment = {};

	doc.descendants((node, pos) => {
		const id = commentIdOf(node);
		if (!id) return;

		const from = pos;
		const to = pos + node.nodeSize - 1;

		comments[id] = comments[id]
			? { from: Math.min(comments[id].from, from), to: Math.max(comments[id].to, to) }
			: { from, to };
	});

	return comments;
};

export default collectComments;
